import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Button,
  
} from 'reactstrap';

import "./index.css";


const PrivacyPage = () => {

  return (
    <div className="bg-grey py-3 mt-8">
      <Container fluid>
        <Row>
          <Col lg="12" xl="12">
            <div className="text-center text-white mb-4">
              <h1 className="display-4 font-weight-bold">Fred S. Keller Store Privacy Policy</h1>
              <h3 className="lead">Effective Date: September 16, 2025</h3>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className="mt-4" fluid>
        <Row className="justify-content-center align-items-start">
          <Col lg="8" xl="8">
            <Card className="shadow-sm terms-card">
              <CardBody className="p-4">

                <section className="mb-4">
                  <p>Your privacy is important to us. This Privacy Policy outlines how the <strong>Fred S. Keller Store</strong> gathers, uses, stores, and discloses information acquired through your use of our websites and applications (collectively, the "Service") or when you communicate with us.</p>
                  
                  <p>As a company based in the United States, the <strong>Fred S. Keller Store</strong> acts as the data controller responsible for your personal data. You can find our contact details on our website. By using our Service, you agree to the terms of this policy. If you do not agree, please refrain from using our Service.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">Information We Collect</h2>
                  <h3 className="h6 mb-3">Data Collection</h3>
                  <p>When you sign up for our services, we may ask for personal details such as your name, email address, password, and credit card information. When you register a user, whom we refer to as a <strong>"Learner,"</strong> we may also collect their name, age, and, if you choose, sensitive data like their diagnosis or medications.</p>

                  <p>As you interact with the Service, we automatically log Traffic Data, including your IP address, browser type, viewed pages, and links clicked. We use cookies and web beacons to optimize your browsing experience.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">How We Use Your Data</h2>
                  <p>We utilize your Personal Information to facilitate account creation, process financial transactions, and provide customer support. For Learners, this information allows us to deliver our assessment and learning tools and to generate progress reports. Traffic Data helps us analyze platform usage and enhance our Service.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">Data Sharing and Disclosure</h2>
                  <p>We want to be clear: we do not sell Personal Information. We may, however, share your data with trusted third-party vendors who perform services on our behalf, such as platform operation and maintenance. These partners are under a contractual obligation to protect your information. We may also release data if required to do so by law or to protect our legal interests.</p>

                  <h3 className="h6 mb-3">Third-Party Service Providers</h3>
                  <p>We partner with various third parties to support our Service. These providers may process Personal Information strictly to carry out their contracted functions and are required to uphold strict confidentiality and security standards.</p>

                  <p><strong>Examples of our service providers include:</strong></p>
                  <ul>
                    <li><strong>Amazon Web Services (AWS)</strong> – for secure data hosting.</li>
                    <li><strong>Intercom</strong> – for in-app messaging and user assistance.</li>
                    <li><strong>Stripe</strong> – for handling secure payments.</li>
                    <li><strong>Vanta</strong> – for monitoring security and compliance.</li>
                  </ul>

                  <p>A complete and up-to-date list of our partners is available upon request.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">Data Security and Retention</h2>
                  <h3 className="h6 mb-3">Security Measures</h3>
                  <p>We are dedicated to safeguarding your data and adhering to the Health Insurance Portability and Accountability Act (HIPAA). All learner and user information is protected within encrypted databases hosted by Amazon Web Services (AWS). We employ industry-standard encryption methods for data both in transit and at rest.</p>

                  <h3 className="h6 mb-3">Data Retention</h3>
                  <p>We keep Personal Information for as long as needed to fulfill the purposes outlined in this policy, unless a longer period is mandated by law. Data permanently deleted by a user is purged from our active systems within 30 days and removed from backups according to our retention protocols.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">Your Rights and Other Information</h2>
                  <h3 className="h6 mb-3">Your Rights</h3>
                  <p>You have the right to unsubscribe from marketing communications, request a disclosure or deletion of your Personal Information, and ask for a copy or transfer of your data. We will not penalize you for exercising these rights.</p>

                  <h3 className="h6 mb-3">External Links</h3>
                  <p>Our Service may feature links to other websites with different privacy practices. We are not responsible for the content or policies of these external sites, and we recommend that you review their privacy policies.</p>

                  <h3 className="h6 mb-3">Children's Privacy</h3>
                  <p>Our Service is not intended for individuals under 18 years of age. If we learn that a minor under 18 has provided us with Personal Information, we will promptly delete that data.</p>

                  <h3 className="h6 mb-3">Policy Changes</h3>
                  <p>We may periodically amend this Privacy Policy. When we do, we will update the Effective Date at the top of the page. Your continued use of the Service after any changes indicates your acceptance of the new terms.</p>
                </section>

                <div className="text-center text-muted mt-5 pt-4 border-top">
                  <small>© 2025 Fred S. Keller Store. All rights reserved.</small>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPage;